/**
 * Version 1 is immutable: it remaps the legacy Event ID state stored under TradeID.
 * Use a separate migration marker for future LP Settlement layout migrations.
 */
export const LP_SETTLEMENT_GRID_LAYOUT_MIGRATION_VERSION = 1;

/** Run migration when stored version is missing or below current version. */
export function shouldRunLpSettlementGridLayoutMigration(config: {
  lpSettlementGridLayoutMigrationVersion?: number;
}): boolean {
  const version = config.lpSettlementGridLayoutMigrationVersion;
  return version == null || version < LP_SETTLEMENT_GRID_LAYOUT_MIGRATION_VERSION;
}
